import { render, staticRenderFns } from "./SlyderE.vue?vue&type=template&id=0dea9229&lang=pug&"
import script from "./SlyderE.vue?vue&type=script&lang=js&"
export * from "./SlyderE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports